import { useCustomMutation } from "@/hooks/use-graphql-client";

import { RoomPriceRankUpdate_RoomPriceRankPage_Mutation } from "./mutation";

export const useUpdateRoomPriceRank = () => {
	const { mutationFunc } = useCustomMutation(RoomPriceRankUpdate_RoomPriceRankPage_Mutation);

	return {
		mutationFunc,
	};
};
